import './assets/base.css'
import { createApp } from "vue";

import ElementPlus from 'element-plus';
import 'element-plus/theme-chalk/index.css';
import App from "./App.vue";
import store from "./store";
import router from "./router";
import "./assets/css/nucleo-icons.css";
import "./assets/css/nucleo-svg.css";
import ArgonDashboard from "./argon-dashboard";
import vue3GoogleLogin from 'vue3-google-login';
const appInstance = createApp(App);


appInstance.use(ElementPlus);
appInstance.use(vue3GoogleLogin,{
    clientId:"453300074588-9t9n2jluakigkamsivq50l24es9l11a2.apps.googleusercontent.com",
    scope:"profile email"
})
appInstance.use(store);
appInstance.use(router);
appInstance.use(ArgonDashboard);
appInstance.mount("#app");
